// extracted by mini-css-extract-plugin
export var eyebrow = "_d1-3";
export var heroImage = "_d1-4";
export var main = "_d1-2";
export var modal = "_d1-0";
export var shell = "_d1-1";